/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Band_AsideInputs */

const en_shop_band_aside = /** @type {(inputs: Shop_Band_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take the training home: guides and gear from your trainer.`)
};

const pl_shop_band_aside = /** @type {(inputs: Shop_Band_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zabierz trening do domu: poradniki i sprzęt od Twojego trenera.`)
};

/**
* | output |
* | --- |
* | "Take the training home: guides and gear from your trainer." |
*
* @param {Shop_Band_AsideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const shop_band_aside = /** @type {((inputs?: Shop_Band_AsideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Band_AsideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_shop_band_aside(inputs)
	return en_shop_band_aside(inputs)
});